/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useMemo, useLayoutEffect, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import objectPath from 'object-path';
import { getBreadcrumbsAndTitle, useSubheader } from '../../_core/MetronicSubheader';
import { useHtmlClassService } from '../../_core/MetronicLayout';
// import { BreadCrumbs } from './components/BreadCrumbs';
// import * as MenuConfig from '../MenuConfig.js';
import ReturnIcon from 'src/common/utils/TableColumnIcons/ReturnIcon';

export function SubHeader({ hideSidebar }) {
	const uiService = useHtmlClassService();
	const { pathname } = useLocation();
	const subheader = useSubheader();

	const layoutProps = useMemo(() => {
		return {
			config: uiService.config,
			subheaderMobileToggle: objectPath.get(
				uiService.config,
				'subheader.mobile-toggle'
			),
			subheaderCssClasses: uiService.getClasses('subheader', true),
			subheaderContainerCssClasses: uiService.getClasses(
				'subheader_container',
				true
			),
		};
	}, [uiService]);

	useLayoutEffect(() => {
		const aside = getBreadcrumbsAndTitle('kt_aside_menu', pathname);
		const header = getBreadcrumbsAndTitle('kt_header_menu', pathname);
		const breadcrumbs =
			aside && aside.breadcrumbs.length > 0
				? aside.breadcrumbs
				: header.breadcrumbs;
		subheader.setBreadcrumbs(breadcrumbs);
		subheader.setTitle(
			aside && aside.title && aside.title.length > 0 ? aside.title : header.title
		);
		// eslint-disable-next-line
	}, [pathname]);

	// Do not remove this useEffect, need from update title/breadcrumbs outside (from the page)
	useEffect(() => {}, [subheader]);

	const onreturn = () => window.history.back();

	return (
		<div
			id="kt_subheader"
			className={`subheader py-2    ${layoutProps.subheaderCssClasses} ${
				hideSidebar ? 'hidden-sidebar' : ''
			}`}
		>
			<div id="kt_subheader">
				<div className="d-flex justify-content-end ">
					<ReturnIcon onClick={() => onreturn()} />
				</div>
			</div>
		</div>
	);
}
